import { GetListParams, GetListResult, GetManyReferenceParams, GetManyReferenceResult, RaRecord } from 'react-admin';
import { getJson } from '../../../utils/api';
import IHandler from './IHandler';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(tz);

interface Statement {
  timestamp: string;
  email: string;
  minimalPayment: number;
  transactionIds: string[];
  creditLimit: number;
  periodStart: string;
  address: {
    postCode: string;
    address3: string;
    address2: string;
    city: string;
    address1: string;
  };
  cardName: string;
  paymentDueDate: string;
  userId: string;
  periodEnd: string;
  previousBalance: number;
  paymentIds: string[];
  fee: number;
  filePath: string;
  newBalance: number;
  lastName: string;
  firstName: string;
}

export default class UserStatementsHandler implements IHandler {
  static resourceIdName = 'timestamp';

  static async getStatementHandler(userId: string, timestamp: string): Promise<{ url: string }> {
    return getJson(`/admin/user/${userId}/statements/${timestamp}`).then(async (response) => {
      const { data: responseData } = await response.json();

      return {
        ...responseData,
      };
    });
  }

  static async getListHandler<RecordType extends RaRecord = any>(
    resource?: string,
    params?: GetListParams
  ): Promise<GetListResult<RecordType>> {
    const query: { [key: string]: any } = {
      limit: params?.pagination.perPage ?? 10,
    };

    if (params?.filter.nextToken != null) {
      query.nextToken = params?.filter.nextToken;
    }

    const userId = params?.filter?.userId;

    return getJson(`/admin/user/${userId}/statements?${new URLSearchParams(query).toString()}`).then(
      async (response) => {
        let { data: responseData } = await response.json();

        const nextToken = responseData.nextToken;

        responseData = responseData?.cardStatementsList || [];

        responseData = responseData.map((data: any) => {
          const result = {
            ...data,
          };

          result.id = data[this.resourceIdName];
          delete result[this.resourceIdName];

          return {
            ...result,
          };
        });

        return {
          data: responseData,
          pageInfo: {
            hasNextPage: !!nextToken,
          },
          nextToken,
        };
      }
    );
  }

  static async getManyReference<RecordType extends RaRecord = any>(
    resource: string,
    params: GetManyReferenceParams
  ): Promise<GetManyReferenceResult<RecordType>> {
    const data: any[] = [];

    let nextToken = null;
    do {
      const ret: any = await UserStatementsHandler.getListHandler(resource, {
        filter: {
          userId: params?.id,
          ...params.filter,
          nextToken,
        },
        meta: params.meta,
        pagination: params.pagination,
        sort: params.sort,
      });
      console.log(ret);
      nextToken = ret.nextToken;
      data.push(...ret.data);
    } while (nextToken != null);

    return {
      data: UserStatementsHandler.postProcessTransactions(data) as unknown as RecordType[],
      pageInfo: {
        hasNextPage: false,
      },
    };
  }

  static postProcessTransactions(data: Statement[]): Statement[] {
    return data;
  }
}
